<template>
  <tr>
    <td>
      <a class="text-decoration-underline" @click="$emit('open-form', item)">
        {{ item.rule_type | humanize }}
      </a>
    </td>
    <td style="max-width: 300px;">
      <tree-item
        v-if="item.channel"
        :tree-id="item.tree_id"
        :item="item.channel"
        :country-code="item.localization"
      />
      <span v-else>Unavailable</span>
    </td>
    <td>
      <CountryBadge :country="resolveCountryCode(item.localization)" />
    </td>
    <td>
      {{ item.process_type | humanize }}
    </td>
    <td>{{ item.status | humanize }}</td>
    <td>{{ item.created_by }}</td>
    <td>{{ item.updated_at | time }}</td>
  </tr>
</template>

<script>
import CountryBadge from '@/components/CountryBadge';
import TreeItem from '@/components/cls/TreeItem.vue';
import { resolveCountryCode } from '@/helpers/filters';

export default {
  components: { TreeItem, CountryBadge },
  props: {
    item: {
      type: Object,
      required: true,
    },
    mv: {
      type: Boolean,
      default: false,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    showChanges: {
      type: Boolean,
      default: false,
    },
    ios: {
      type: Boolean,
      default: false,
    },
    android: {
      type: Boolean,
      default: false,
    },
    video: {
      type: Boolean,
      default: false,
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    resolveCountryCode,
  },
};
</script>
